var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPayout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.501,
    height: 22.44,
    viewBox: "0 0 24.501 22.44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1767"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3950",
    d: "M209.78 272.06h-9.25a1 1 0 0 1-1-1v-13a1 1 0 0 1 1-1h21a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1h.16",
    transform: "translate(-198.779 -256.31)",
    style: {
      stroke: "#191919",
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1774",
    transform: "translate(.75 3.689)",
    style: {
      stroke: "#191919",
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    },
    d: "M0 0h23v3H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 1255",
    transform: "translate(2.75 11.689)",
    style: {
      stroke: "#191919",
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    },
    d: "M0 0h4"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 1256",
    transform: "translate(9.75 11.689)",
    style: {
      stroke: "#191919",
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    },
    d: "M0 0h3"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 1257",
    transform: "translate(16.92 12.03)",
    style: {
      stroke: "#2a32ff",
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    },
    d: "M3.78 3.78 0 0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 1258",
    transform: "translate(13.141 12.03)",
    style: {
      stroke: "#2a32ff",
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    },
    d: "M0 3.78 3.78 0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 1259",
    transform: "translate(16.92 12.03)",
    style: {
      stroke: "#2a32ff",
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    },
    d: "M0 9.66V0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayout);
export default __webpack_public_path__ + "static/media/payout.91be830d90584e2fca866b1804c90c8a.svg";
export { ForwardRef as ReactComponent };